import React from 'react';
import { useState } from 'react';
import LoaderTri from '../../components/Loader/LoaderTri';
import { Image } from 'antd';
import { variableName } from '../../variableName';

const ContactUs = () => {

    const [isLoading, setIsLoading] = useState(true);

    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-7 text-center '>
                    <br />
                    {isLoading && <LoaderTri />}
                    {/* <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2194.67009972243!2d76.10946350133062!3d15.967418589683977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb80d5a4ae15733%3A0x6e524b742298456a!2sAshok%20Medical%20Agencies!5e0!3m2!1sen!2sin!4v1745816666201!5m2!1sen!2sin"
                        width="90%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="eager"
                        referrerPolicy="no-referrer-when-downgrade"
                        onLoad={() => {
                            console.log("onLoad");
                            setIsLoading(false);
                        }}
                        title='Google Map  '
                    ></iframe> */}

                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3818.822137075761!2d75.7184126!3d16.8351775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc655819fea265d%3A0xe274da0bc372555b!2sSUPRABHAT%20PHARMACEUTICALS!5e0!3m2!1sen!2sin!4v1770179251992!5m2!1sen!2sin"
                        width="90%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="eager"
                        referrerPolicy="no-referrer-when-downgrade"
                        onLoad={() => {
                            console.log("onLoad");
                            setIsLoading(false);
                        }}
                        title='Google Map  '
                    ></iframe>
                    <br />


                    <div className='' style={{
                        paddingLeft: 70,
                        paddingRight: 70,

                    }}>
                        {/* <h4 className='text-start '>PHONE NO</h4> */}
                        <br />
                        {/* <div className='text-start'><u style={{ fontWeight: 500 }}>Phone No</u>: 08062180360</div> */}
                        <div className='text-start'><u style={{ fontWeight: 500 }}>Mobile No</u>: 08062180360</div>
                        {/* <div className='text-start'><u style={{ fontWeight: 500 }}>Email</u> : ashokmedical.ilkal@gmail.com</div>
                        <div className='text-start'><u style={{ fontWeight: 500 }}>Web Site</u> :<a href='https://www.ashokmedicalagencies.com' target='_blank' rel="noopener noreferrer">https://www.ashokmedicalagencies.com</a></div> */}
                        <div className='text-start'><u style={{ fontWeight: 500 }}>Android/IOS APP</u> : <a href='https://sites.google.com/view/suprabhat-app/home' rel='noopener noreferrer' target='_blank'>
                            {variableName.outerHeaderName}
                        </a>
                        </div>
                    </div>


                    <br />
                    <br />
                </div>
                <div className='col-md-5'>
                    <br />
                    {/* <br />
                    <br /> */}

                    <div className=' ' style={{ width: "90%" }}>
                        <h4>{variableName.outerHeaderName}</h4>

                        <h6 >
                            Banashankari Complex, Akkamahadevi St, near Anand Hospital, Gacchinakatti Colony, Vijayapura, Karnataka 586101
                        </h6>
                        <br />
                        {/* <Image

                            src={sushilContactImage}
                            width={"100%"}
                            height={"auto"}
                        /> */}

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactUs